import * as constants from './OrderDetail.constants';
import * as services from './OrderDetail.service';

const state = {
  MyOrderDetail: {},
  isRequest: false,
};

const mutations = {
  [constants.GET_MARKET_TRADE_DETAIL_SUCCESS](state, MyOrderDetail) {
    if (undefined !== MyOrderDetail && null !== MyOrderDetail) {
      state.MyOrderDetail = MyOrderDetail;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, data) {
    state.isRequest = data;
  },
};

const actions = {
  async getMarketTradeDetail({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    try {
      const res = await services.getMarketTradeDetail(payload);
      if (res.data.data) {
        commit(constants.GET_MARKET_TRADE_DETAIL_SUCCESS, res.data.data);
      }
    } catch (e) {
      commit(constants.GET_MARKET_TRADE_DETAIL_SUCCESS, null);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  MyOrderDetail: (state) => {
    const MyOrderDetail = state.MyOrderDetail;
    return {
      ...MyOrderDetail,
      used_points_money: MyOrderDetail.used_points / 100,
      isFree: 0 === MyOrderDetail.realPrice,
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
